import React, { useEffect } from "react";
import Modal from "@components/_Revamp/Modal";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription/TitleAndDescription";
import Button from "@components/_Revamp/Button";
import { styled } from "@linaria/react";
import { isNull } from "lodash";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { Text } from "../Text";
import { css } from "@linaria/core";
import { SCREEN_SIZE } from "@static/screen-size";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ErrorContainer = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -40px;
  margin-bottom: 40px;
  padding: "0 10px";
  text-align: center;
  font-style: normal;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
  color: #8a8988;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-weight: 600;
  }
`;

interface ErrorModal {
  error: string;
  onCloseFn?: () => void;
  title?: string;
}

const titleCss = css`
  white-space: break-spaces;
`;

function ErrorModal({ error, onCloseFn, title }: ErrorModal) {
  const history = useHistory();
  const isErrorModal = onCloseFn ? false : true;
  let formatedError = error.replaceAll("\\n\\n", "\n\n");
  formatedError = formatedError.replaceAll("\\n", "\n");

   //AA Page Loading
 useEffect(()=>{
  if(window.location.hash.includes("under-writing-1a")){
  trackOnLoad({},"you-may-need-some-assistance")}else{
    trackOnLoad()
  }
},[])


  return (
    <Modal
      show={!isNull(error)}
      isErrorModal={isErrorModal}
      onClose={onCloseFn}
    >
      <Text
        variant="title"
        align="center"
        margin={"0 0 60px 0"}
        textClass={titleCss}
      >
        {title || "We've encountered an issue"}
      </Text>

      <ErrorContainer>
        {error &&
          formatedError.split(/\r\n|\n|\r/gm).map((line) => {
            return (
              <>
                {line}
                <br />
              </>
            );
          })}
      </ErrorContainer>
      <ButtonContainer>
        <Button
          variant="default"
          label="Contact us"
          width="180px"
          height="52px"
          onClick={() => {
            trackOnCTA({
              ctaText:"Contact Us",
              ctaType:"qb:link",
            })
            isErrorModal
              ? history.push({
                  pathname: ROUTE_PATH.CANCER_COVER_CONTACT_US,
                  state: { noBackButton: true },
                })
              : history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
          }}
        />
      </ButtonContainer>
    </Modal>
  );
}

export default ErrorModal;
